import {
    ADD_MANUFACTURER_FAIL,
    ADD_MANUFACTURER_SUCCESS,
    DELETE_MANUFACTURER_FAIL,
    DELETE_MANUFACTURER_SUCCESS,
    EXPORT_MANUFACTURER_FAIL,
    EXPORT_MANUFACTURER_SUCCESS,
    GET_MANUFACTURER_DETAILS_FAIL,
    GET_MANUFACTURER_DETAILS_SUCCESS,
    GET_MANUFACTURER_LISTING_FAIL,
    GET_MANUFACTURER_LISTING_SUCCESS,
    RESET_MANUFACTURER_ATTACHMENT_STATE,
    RESET_MANUFACTURER_STATE,
    UPDATE_MANUFACTURER_FAIL,
    UPDATE_MANUFACTURER_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    manufacturerListing: [],
    manufacturerDetails: [],
    addManufacturer: [],
    updateManufacturer: [],
    deleteManufacturer: [],
    exportManufacturer: [],
    error: [],
}

const Manufacturer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_MANUFACTURER_LISTING_SUCCESS:
            return {
                ...state,
                manufacturerListing: action.payload
            }
        case GET_MANUFACTURER_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_MANUFACTURER_DETAILS_SUCCESS:
            return {
                ...state,
                manufacturerDetails: action.payload
            }
        case GET_MANUFACTURER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_MANUFACTURER_SUCCESS:
            return {
                ...state,
                addManufacturer: action.payload
            }
        case ADD_MANUFACTURER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_MANUFACTURER_SUCCESS:
            return {
                ...state,
                updateManufacturer: action.payload
            }
        case UPDATE_MANUFACTURER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_MANUFACTURER_SUCCESS:
            return {
                ...state,
                deleteManufacturer: action.payload
            }
        case DELETE_MANUFACTURER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_MANUFACTURER_SUCCESS:
            return {
                ...state,
                exportManufacturer: action.payload
            }
        case EXPORT_MANUFACTURER_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_MANUFACTURER_STATE:
            return {
                ...state,
                manufacturerListing: [],
                manufacturerDetails: [],
                addManufacturer: [],
                updateManufacturer: [],
                deleteManufacturer: [],
                exportManufacturer: [],
                error: [],
            }
        case RESET_MANUFACTURER_ATTACHMENT_STATE:
            return {
                ...state,
                exportManufacturer: [],
                error: [],
            }
        default:
            return state
    }
}

export default Manufacturer
